/**
 * ContentRepository module
 *
 * This module create shortcut with a request
 * to the API
 *
 */

'use strict';

const RequestHandler = require('./../../../core/requestHandler');
const Container = require('./../../../core/container');

module.exports.findAll = function() {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd;

    dfd = RequestHandler.read('group');

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};

module.exports.getPermissions = function(userId) {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let $toolbar = Container.get('$toolbar');
    let dfd;

    RequestHandler.setBaseUrl('/api');

    dfd = RequestHandler.read('user-rights/current-user-rights', {'contextual_page_uid': $toolbar.data('page-uid')});

    RequestHandler.setBaseUrl(currentApiUrl);

    return dfd;
};
